import Cookies from 'js-cookie';

const COOKIE_NAME = 'token';

export const getToken = () => Cookies.get(COOKIE_NAME);

/**
 * 認証トークンを Cookie に保存する。
 * 認証トークンの Cookie を http の通信で送らせないために、必ず `secure: true` を付ける。
 * セキュリティを優先して呼び出し側からは外せないようにしているので、`secure` は `options` の後に置く。
 */
export const setToken = (token: string, options?: Cookies.CookieAttributes) =>
  Cookies.set(COOKIE_NAME, token, { ...options, secure: true });
export const removeToken = () => Cookies.remove(COOKIE_NAME);
